import {useEffect} from 'react'
import {QuotesEditModalHeader} from './QuotesEditModalHeader'
import {QuotesEditModalFormWrapper} from './QuotesEditModalFormWrapper'

const QuotesEditModal = () => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
        
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered modal-lg'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <QuotesEditModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y'>
              <QuotesEditModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {QuotesEditModal}
